export default {"src":"/_next/static/media/infrastructure.7f42597c.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};